(function () {
  if (!/leak-proof-4-in-1-travel-dispenser/.test(window.location.pathname)) return;

  var CHUNK_NAMES = ["pp-l0.js", "pp-l1.js", "pp-l2a.js", "pp-l2b.js", "pp-l3.js", "pp-l4.js", "pp-l5.js", "pp-r0.js", "pp-r1a.js", "pp-r1b.js", "pp-r2.js", "pp-r3a.js", "pp-r3ba.js", "pp-r3bb.js"];

  function getBaseUrl() {
    var cur = document.currentScript;
    if (cur && cur.src) return cur.src.replace(/pagepilot-gallery\.js.*$/, "");
    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src && scripts[i].src.indexOf("pagepilot-gallery.js") !== -1) {
        return scripts[i].src.replace(/pagepilot-gallery\.js.*$/, "");
      }
    }
    return null;
  }

  function loadChunk(url) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = url;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error("failed to load " + url)); };
      document.head.appendChild(s);
    });
  }

  function findGalleryAnchor() {
    var vf = document.getElementById("cc-video-feature");
    if (vf) return vf;
    var el = document.querySelector('[id^="shopify-section-"][id$="multicolumn_1"]');
    if (el) return el;
    var sections = document.querySelectorAll('[id^="shopify-section-"]');
    if (sections.length) return sections[sections.length - 1];
    return document.querySelector('main');
  }

  function injectTwoImageSection() {
    if (document.getElementById("cc-two-img")) return true;
    var anchor = findGalleryAnchor();
    if (!anchor) return false;

    var LEFT_IMG = "data:image/jpeg;base64," + window.__CC_L0 + window.__CC_L1 + window.__CC_L2a + window.__CC_L2b + window.__CC_L3 + window.__CC_L4 + window.__CC_L5;
    var RIGHT_IMG = "data:image/jpeg;base64," + window.__CC_R0 + window.__CC_R1a + window.__CC_R1b + window.__CC_R2 + window.__CC_R3a + window.__CC_R3ba + window.__CC_R3bb;

    var html = ""
      + "<style>"
      + "#cc-two-img{max-width:1100px;margin:0 auto;padding:48px 24px;}"
      + "#cc-two-img .cc-ti-row{display:flex;gap:32px;}"
      + "#cc-two-img .cc-ti-col{flex:1;text-align:center;}"
      + "#cc-two-img .cc-ti-col img{display:block;width:100%;height:auto;border-radius:14px;object-fit:cover;}"
      + "#cc-two-img .cc-ti-caption{margin-top:14px;font-size:13px;line-height:1.6;color:#4c4845;}"
      + "@media (max-width:749px){"
      + "#cc-two-img{padding:32px 20px;}"
      + "#cc-two-img .cc-ti-row{flex-direction:column;gap:24px;}"
      + "}"
      + "</style>"
      + "<div id=\"cc-two-img\">"
      + "<div class=\"cc-ti-row\">"
      + "<div class=\"cc-ti-col\">"
      + "<img src=\"" + LEFT_IMG + "\" alt=\"Compact and portable travel dispenser\" loading=\"lazy\">"
      + "<p class=\"cc-ti-caption\">Compact and portable — slips into any suitcase pocket without eating up your packing space.</p>"
      + "</div>"
      + "<div class=\"cc-ti-col\">"
      + "<img src=\"" + RIGHT_IMG + "\" alt=\"Dispenser refill bottles and labels\" loading=\"lazy\">"
      + "<p class=\"cc-ti-caption\">Includes labeled refill vials, so every bottle is clearly marked and easy to refill on the go.</p>"
      + "</div>"
      + "</div>"
      + "</div>";

    anchor.insertAdjacentHTML("afterend", html);
    return true;
  }

  function afterChunksLoaded() {
    if (!injectTwoImageSection()) {
      document.addEventListener("DOMContentLoaded", injectTwoImageSection);
      var tries2 = 0;
      var poll2 = setInterval(function () {
        tries2++;
        if (injectTwoImageSection() || tries2 > 30) clearInterval(poll2);
      }, 250);
    }
  }

  var base = getBaseUrl();
  if (!base) return;

  var loads = [];
  for (var i = 0; i < CHUNK_NAMES.length; i++) {
    loads.push(loadChunk(base + CHUNK_NAMES[i]));
  }

  Promise.all(loads).then(afterChunksLoaded, function (err) {
    if (window.console && console.error) console.error(err);
  });
})();
